import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Lock } from "lucide-react";
import { KgdLogo } from "@/components/Layout";

export default function AdminLogin() {
    const { user, login } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const nav = useNavigate();

    if (user && user.role === "admin") return <Navigate to="/administration/tableau" replace/>;

    const submit = async (e) => {
        e.preventDefault();
        setError(""); setLoading(true);
        try {
            await login(email, password);
            nav("/administration/tableau");
        } catch (err) {
            setError(formatApiErrorDetail(err.response?.data?.detail));
        } finally { setLoading(false); }
    };

    return (
        <div className="min-h-[70vh] flex items-center justify-center px-5 py-16" style={{ background: "linear-gradient(160deg,#050F22,#0A2555)" }}>
            <form onSubmit={submit} className="w-full max-w-md glass-card rounded-2xl p-8">
                <div className="flex justify-center mb-4"><KgdLogo className="h-12" compact/></div>
                <div className="text-center">
                    <div className="eyebrow">Espace administratif</div>
                    <h1 className="font-serif text-2xl text-white mt-2">Connexion</h1>
                </div>
                <div className="mt-6 space-y-4">
                    <div>
                        <label className="text-xs text-white/70">Courriel</label>
                        <input data-testid="admin-email" type="email" required autoComplete="email" className="w-full mt-1 rounded-lg bg-white/10 border border-white/20 px-3 py-2 text-white focus:border-kgd-gold outline-none" value={email} onChange={e => setEmail(e.target.value)}/>
                    </div>
                    <div>
                        <label className="text-xs text-white/70">Mot de passe</label>
                        <input data-testid="admin-password" type="password" required autoComplete="current-password" className="w-full mt-1 rounded-lg bg-white/10 border border-white/20 px-3 py-2 text-white focus:border-kgd-gold outline-none" value={password} onChange={e => setPassword(e.target.value)}/>
                    </div>
                    {error && <div className="text-xs text-red-300" data-testid="admin-login-error">{error}</div>}
                    <button data-testid="admin-login-submit" type="submit" disabled={loading} className="btn-gold w-full"><Lock className="w-4 h-4"/> {loading ? "Connexion..." : "Se connecter"}</button>
                </div>
            </form>
        </div>
    );
}
